<template>
  <div id="app">
    <div v-if="isAuthenticated" id="menuLeft" class="ui vertical menu">
      <div class="item btn_home">
        <img src="~@/assets/top-logo.png" />
      </div>

      <customer ref="customer">
        <a slot="activator" class="ui button small green btn_customer">
          <i class="user circle icon"></i> {{ $t('Search / Add customer') }}
        </a>
      </customer>

      <a
        v-if="currentCustomer"
        class="ui button small green btn_customer"
        @click="redirectToHome()"
        >{{ $t('Back to home') }}
      </a>

      <a
        v-for="(customer, index) in customers"
        :key="index"
        :class="[
          currentCustomer && currentCustomer.id == customer.id
            ? 'item customer active'
            : 'item customer'
        ]"
        @click="loadCustomer(customer)"
      >
        <div class="content user-card">
          <a class="header">{{
            customer.firstname + ' ' + customer.lastname
          }}</a>
          <div class="extra">
            <div class="ui label">
              <i class="cart icon"></i>
              <span v-if="customer.cart && customer.cart.products">{{ customer.cart.products.length }} shirt(s)</span>
              <span v-else>Error</span>
            </div>
            <a class="ui tag label" v-if="getTotalPrice(customer) > 0">{{ getTotalPrice(customer) | price }} </a>
          </div>
        </div>
      </a>
    </div>

    <div v-if="isAuthenticated" class="menu-content">
      <router-view></router-view>
    </div>

    <authentication v-if="!isAuthenticated"></authentication>

    <div v-if="isLoading" class="loader">
      <i class="loading spinner icon"></i>
    </div>
  </div>
</template>

<style scoped>
html,
body,
#app {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  max-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
  overflow: hidden;
}

.ui.menu .item.btn_home {
  color: green !important;
  background-color: #fff !important;
  padding: 20px 0;
}

.ui.button.btn_customer {
  display: block;
  margin: 10px;
  padding: 10px 0;
  text-align: center;
}

.menu .item {
  border-radius: 0 !important;
  color: white;
}

.ui.menu .item {
  padding-left: 10px;
  padding-right: 10px;
}

.ui.vertical.menu .active.item {
  background-color: rgba(255, 255, 255, 0.5);
}

.menu-content {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
  padding: 15px;
}

#menuLeft {
  min-width: 15rem;
  margin: 0;
  background: #1b1c1d;
  border: 0 solid transparent;
}

.user-card .header {
  color: #fff;
}

.user-card .extra {
  margin-top: 10px;
}

.selector {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.loader {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 999;

  /* background-color: #fff; */
}

.loader i {
  font-size: 42px;
}
</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { round } from 'lodash'

import Authentication from './views/Authentication'
import CustomerModal from './components/Modal/CustomerModal'

export default {
  name: 'App',
  components: {
    customer: CustomerModal,
    authentication: Authentication
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      customers: 'getCustomers',
      currentCustomer: 'getCurrentCustomer',
      isAuthenticated: 'isAuthenticated',
      isLoading: 'isLoading',
      pricePrecision: 'getPricePrecision',
    })
  },
  watch: {
    isAuthenticated(val) {
      /* When an user is logged in, we update the local data. */
      if (val) {
        axios.get('/countries').then((response) => {
          this.$store.commit('setCountries', response.data.countries)
        })

        axios.get('/designer').then((response) => {
          this.$store.dispatch('setTemplates', response.data.designs)
        })
      }
    }
  },
  mounted() {},
  methods: {
    openCustomerModal() {
      const { customer } = this.$refs
      customer.open()
    },
    loadCustomer(customer) {
      this.$store.dispatch('setCurrentCustomer', customer)
      this.$router.push({ name: 'CustomerView' })
    },
    getTotalPrice(customer) {
      let price = 0
      if (!customer.cart || !customer.cart.products) {
        return price
      }

      customer.cart.products.forEach((product) => {
        price += product.price
      })

      return round(price, this.pricePrecision)
    },
    redirectToHome() {
      this.$store.dispatch('setCurrentCustomer', {})
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?1a36977d